import Breadcrumb from "../components/Breadcrumb";
import AddPlan from "../components/AddPlan";

const AddPlanPage = () => {
  return (
    <>
      <Breadcrumb title="Add Plan" />

      <AddPlan />
    </>
  );
};

export default AddPlanPage;
